import request from '@/utils/request'
const apiPath = '/cust/customerOrderAfter'
const apiPathFe = '/sys/customerLevel'
const apiPathGoods = '/cust/customerOrder'
const apiPathGoodsList = '/cust/customerOrderGoods'
const apiDeliveryList = '/sys/sysExpress/tee/list'
const apiUserList = '/cust/customer/customerList2'
const apiUserAddrList = '/cust/customerAddress'
import { downloadBlob } from '@/utils/download'
const goodsOrderApi = {
  // 确认认领
  confirmClaim(query) {
    return request.post(apiPath + '/tee/confirmClaim', query)
  },
  // 终止售后
  afterEnd(query) {
    return request.post(apiPath + '/tee/end', query)
  },
  // 终止售后(审核状态)
  endForAudit(query) {
    return request.post(apiPath + '/tee/endForAudit', query)
  },
  //验货签收
  afterSigned(query) {
    return request.post(apiPath + '/tee/signed', query)
  },
  //驳回签收
  afterSignedReject(query) {
    return request.post(apiPath + '/tee/signedReject', query)
  },
    //撤回售后
    afterrevokeSolution(query) {
      return request.post(apiPath + '/tee/revokeSolution', query)
    },
     //变更申请人
  changeUser(query) {
    return request.post(apiPath + '/tee/changeUser', query)
  },
    //寄回物流
  returnToLogistics(query) {
    return request.post(apiPath + '/tee/returnToLogistics', query)
  },
      //签收物流
  signedLogistics(query) {
    return request.post(apiPath + '/tee/signedLogistics', query)
  },
  // 处理售后
  afterSolution(query) {
    return request.post(apiPath + '/tee/solution', query)
  },
  getlist(query) {
    return request.get(apiPath + '/listNew', { params: query })
  },
  getForList(query) {
    return request.get(apiPath + '/tee', { params: query })
  },
  getChangeOrder(query) {
    return request.get(apiPath + '/ExchangeOrderList', { params: query })
  },
  getExchangeTotal(query) {
    return request.get(apiPath + '/findExchangeOrderTotal', { params: query })
  },
  getAfterTotal(query) {
    return request.get(apiPath + '/findCustomerAfterTotal', { params: query })
  },
  getExchangeDetail(query) {
    return request.get(`${apiPath}/findExchangeOrderById`, { params: query })
  },
  addOrderToYongYou(query) {
    return request.get(apiPath + '/addOrderToYongYou', { params: query })
  },
  findManegeAfterOrderListByPage(query) {
    return request.get(apiPath + '/findManegeAfterOrderListByPage', { params: query })
  },
  downloadImportTemplate(query) {
    let downName = '待认领售后订单.xlsx'
    return request.get(`${apiPath}/downloadImportTemplate`, { responseType: 'blob', params: query })
      .then(res => downloadBlob(res, downName))
  },
  importExcelClaim(query) {
    return request.post(apiPath + '/importExcel', query, { isFormData: 1 })
  },
  AddCustomerOrderAfter(query) {
    return request.post(apiPath + '/AddCustomerOrderAfter', query)
  },
  EditCustomerOrderAfter(query) {
    return request.post(apiPath + '/EditCustomerOrderAfter', query)
  },
  UpdateConfirmOrderAfterState(query) {
    return request.get(`${apiPath}/UpdateConfirmOrderAfterState`, { params: query })
  },
  exportOrderAfterExcel(query) {
    return request.post(apiPath + '/exportOrderAfterExcel', query)
  },
  exchangeOrderExport(query) {
    return request.post(apiPath + '/exchangeOrderExport', query)
  },
  // 商城订单部分--------开始
  getGoodsTotal(query) {
    return request.post(apiPathGoods + '/orderNum', query)
  },
  // 列表
  getGoodsOrder(query) {
    return request.get(apiPathGoods, { params: query })
  },
  // 待支付取消订单
  cancelGoodsOrder(query) {
    return request.post(apiPathGoods + '/cancelNoPayOrder', query, { isFormData: 1 })
  },
  // 取消订单
  cancelOrder(query) {
    return request.post(apiPathGoods + '/cancelOrder', query, { isFormData: 1 })
  },
  // 订单详情
  getGoodsDetail(query) {
    return request.get(`${apiPathGoods}/${query}`)
  },
  // 物流信息
  getLogisticsNumber(query) {
    return request.post(apiPathGoods + '/logisticsNumber', query, { isFormData: 1 })
  },
  // 商品信息
  getGoodsList(query) {
    return request.get(apiPathGoodsList, { params: query })
  },
  // 新增运单号
  addGoodsLogisticsNumber(data) {
    return request.post('/cust/customerOrderDelivery', data)
  },
  //查询用户折扣
  profitRatioCust(query) {
    return request.post(apiPathGoods + `/profitRatioCust`, query, { isFormData: 1 })
  },
  //支付订单
  bgPay(query) {
    return request.post(apiPathGoods + `/bgPay`, query, { isFormData: 1 })
  },
   //支付秒杀订单
   bgPaySeckill(query) {
    return request.post(apiPathGoods + `/bgPay`, query, { isFormData: 1 })
  },
  //订单二维码
  QRcode(query) {
    return request.get(apiPathGoods + `/order/QRcode/${query}`)
  },
  //计算运费
  freight(query) {
    return request.post(apiPathGoods + `/freight`, query, { isFormData: 1 })
  },
  // 推补订单
  goodsTuiOrder(query) {
    return request.post('/sys/tools/sendOrder', query, { isFormData: 1 })
  },
  // 导出
  exportExcelGoods(query, type) {
    let downName = type == 1 ? '商城订单.xlsx' : '积分订单.xlsx'
    return request.get(`${apiPathGoods}/export`, { responseType: 'blob', params: query })
      .then(res => downloadBlob(res, downName))
  },
  coustomerOrderExportExcel(query) {
    return request.get(apiPathGoods + '/coustomerOrderExportExcel', { params: query })
  },
  coustomerOrderGoodsExportExcel(query) {
    return request.get(apiPathGoods + '/coustomerOrderGoodsExportExcel', { params: query })
  },
  coustomerOrderReconciliation(query) {
    return request.get(apiPathGoods + '/coustomerOrderReconciliation', { params: query })
  },
  // 查询快递列表
  getDeliveryList(query) {
    return request.get(apiDeliveryList, { params: query })
  },
  // 添加订单时获取客户资料列表
  getUserList(query) {
    return request.post(apiUserList, query)
  },
  // 根据客户userid查询地址列表
  getUserAddrList(query) {
    return request.get(apiUserAddrList, { params: query })
  },
  // 新增地址
  addUserAddr(query) {
    return request.post(apiUserAddrList, query)
  },
  // 随货同行单列表
  getCustomerCertificatesList(query) {
    return request.get(`${apiPathGoods}/CustomerCertificatesList/${query}`)
  },
  // 根据订货商品获取赠送商品列表
  getSendGoodsList(query) {
    return request.post(apiPathGoods + '/getActivityParameters', query)
  },
  // 后台添加订单
  addHouOrder(query) {
    return request.post(apiPathGoods + '/bgAddOrder', query)
  },
  //后台添加秒杀订单
  bgAddKillOrder(query) {
    return request.post(apiPathGoods + '/bgAddKillOrder', query)
  },
  // 后台订单查询秒杀商品
  findKillGoods(query) {
    return request.get(apiPathGoods + '/findKillGoods', { params: query })
  },
  // 商城订单部分--------结束
  /**
 * 列表订单详情
 */
  getAfterDetail(query) {
    return request.get(`${apiPath}/${query}`)
  },
  // 售后订单待审核时的同意和驳回
  updateOrderAfterState(query) {
    return request.get(apiPath + '/UpdateOrderAfterState', { params: query })
  },
  // 同意售后订单，确定售后方式
  agreeAfter(query) {
    return request.get(apiPath + '/AgreeAfter', { params: query })
  },
  exportExcel(query) {
    return request.get(`${apiPath}/export`, { responseType: 'blob', params: query })
      .then(res => downloadBlob(res, '售后订单.xlsx'))
  },
  /**
  * 列表查询
  */
  fetchList(query) {
    return request.get(apiPathFe + '/tee/list', { params: query })
  },
  // 数据统计【拿货统计】
  getNaHuoStatisticsList(query) {
    return request.get(`${apiPathGoods}/getNaHuoStatisticsList`, { params: query })
  },
  // 售后统计列表
  findAfterTotalByPage(query) {
    return request.get(apiPath + '/findAfterTotalByPage', { params: query })
  },
  // 售后商品排名
  getOrderAfterGoodsRanking(query) {
    return request.get(apiPath + '/getOrderAfterGoodsRanking', { params: query })
  },
  //查询用户钱包信息
  userWallet(query) {
    return request.get(`/cust/userWallet/userWallet/${query}`)
  },
  // 导出 数据统计【拿货统计】excel
  ExportExcels(query) {
    return request.get(apiPathGoods + '/naHuoStatisticsExportExcel', { params: query })
  },
  findAfterTotalExportByQuery(data) {
    return request.post(`${apiPath}/findAfterTotalExportByQuery`, data)
  },
  // 推送erp列表
  getSnedOrderList(data) {
    return request.post(`${apiPathGoods}/getSnedOrderList`, data)
  },
  /**
   * 分页查询【充值礼包记录】
   */
  rechargeGiftRecordList(query) {
    return request.get('/order/rechargeGiftRecord/tee/list', { params: query })
  },
  /**
   * 导出【充值礼包记录】
   */
  rechargeGiftRecordExport(query) {
    return request.get('/order/rechargeGiftRecord/tee/export', { params: query })
  },
    /**
     * 批量核销订单
     * @param {string} ids - 订单id，用英文逗号隔开，如 "1,2,3"
     */
    writeoffBatch(ids) {
      return request.post('/cust/customerOrder/tee/writeoffBatch',  ids)
    },
    /**
     * 批量变更发货订单
     * @param {string} ids - 订单id，用英文逗号隔开，如 "1,2,3"
     */
    changeReceiptMailingBatch(params) {
      return request.post('/cust/customerOrder/tee/changeReceiptMailingBatch',  params)
    },
  /**
   * 待认领售后订单导出
   */
  exportAfterOrderClaim(query) {
    return request.get(apiPath + '/tee/export', { params: query })
  }
 
}
export default goodsOrderApi
